<template>
  <invoice/>
</template>

<script>
import invoice from '../../../components/user-profile/invoice'
export default {
  name: 'InvoiceView',
  components: {
    invoice
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/app/user-profile/invoice.view.vue